<template>
    <loading v-if="loading"></loading>
    <div class="userDetails-top" v-else>
        <img class="img" src="../../assets/image/userBg.png" alt="">
        <!-- <div class="editImg">
            <img src="../../assets/image/editImg.png" alt="">
            <span>上传背景图</span>
        </div> -->
        <!-- <UploadImg v-if="details.id==this.$store.getters.getUserInfo.id" v-model="background" @update="update"></UploadImg> -->
        <div class="userDetails-content">
            <div class="userDetails-top-user">
                <img :src="details.avatar" alt="">
                <div class="userDetails-top-user-right">
                    <!-- 用户信息 -->
                    <div class="userDetails-top-user-right-user">
                        <div class="userDetails-top-user-right-user-name">{{details.nickname}}</div>
                        <div class="userDetails-top-user-right-user-btn" v-if="details.is_follow==0" @click="followUser(details.id)">
                            <i class="el-icon-plus"></i>
                            <span>关注</span>
                        </div>
                        <div class="userDetails-top-user-right-user-btn" v-else @click="followUser(details.id)">
                            <span>取消关注</span>
                        </div>
                    </div>
                    <!-- id -->
                    <div class="userDetails-top-user-right-id">ID：{{details.id}}</div>
                    <div class="userDetails-top-user-right-content">{{details.profile}}</div>
                </div>
            </div>
            <div class="userDetails-top-user-title">他的动态</div>

            <div class="forum" v-loading="forumLoading">
                <!-- 论坛列表 -->
                <forumItem @postLike="postLike" @collect="collect" v-for="(item,index) in list" :key="index" :item="item" @goDetails="goDetails"></forumItem>
                <p v-if="noMore">已经到底了~</p>
                <div class="nodata" v-if="list.length==0&&!forumLoading">
                    <img src="../../assets/image/noData.png" alt="">
                    <span>暂无结果</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import forumItem from '@/components/forum-item/index.vue'
import request from "@/utils/request";
import loading from '@/components/loading/loading.vue'
import UploadImg from '@/components/UploadImg/index.vue'
export default {
    components: {forumItem,loading,UploadImg},
    data(){
        return{
            details:null,
            loading:true,
            list:[],
            background:'',
            query:{
                page:1,
                limit:10,
                type:1,
                user_id:''
            },
            forumLoading:true,
            noMore:false,
        }
    },
    created(){
        this.getDetails()
        this.getList()
    },
    mounted () {
        // window.addEventListener('scroll', this.scrollToTop)
        window.addEventListener('scroll', this.handleScroll);  // 监听（绑定）滚轮滚动事件
        // this.getList()
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods:{
        handleScroll() {
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
               //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                if(!this.noMore){
                    console.log('触底')
                    this.query.limit += 10
                    this.getList()
                }
                //写后台加载数据的函数
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            }          
        },
        update(url){
            this.setBackground(url)
        },
        // 上传用户背景图片
        setBackground(url) {
            request({
                url: "/api/userend/user/uploadBackground",
                method: "post",
                params: {background:url}
            }).then(response => {
                this.$message.success("上传成功")
                this.getDetails()
            });
        },
        // 帖子点赞
        postLike(id) {
            request({
                url: "/api/userend/post/postLike",
                method: "post",
                params: {forum_post_id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_like=!this.list[index].is_like
                if(this.list[index].is_like==0){
                    this.list[index].like_num-=1
                }else{
                    this.list[index].like_num+=1
                }
            });
        },
        // 帖子收藏
        collect(id) {
            request({
                url: "/api/userend/post/collect",
                method: "post",
                params: {id:id}
            }).then(response => {
                let index = this.list.findIndex(item=>{
                    return item.id==id
                })
                this.list[index].is_collect=!this.list[index].is_collect
                this.$parent.info()
            });
        },
        // 关注
        followUser(id) {
            // this.listLoading = true;
            request({
                url: "/api/userend/post/followUser",
                method: "post",
                params: {user_id:id}
            }).then(response => {
                this.details.is_follow=!this.details.is_follow
                if(this.details.is_follow==0){
                    this.$message("已取消")
                }else{
                    this.$message.success("已关注")
                }
                this.$parent.info()
            });
        },
        goDetails(id){
            this.$router.push({
                path:'/forum/forumDetails',
                query:{
                    forum_post_id:id
                }
            })
        },
        // 详情
        getDetails() {
            this.loading = true;
            request({
                url: "/api/userend/post/userinfo",
                method: "get",
                params: {user_id:this.$route.query.user_id}
            }).then(response => {
                this.details = response.data;
                this.loading = false;
            });
        },
        getList() {
            this.forumLoading=true
            this.query.user_id=this.$route.query.user_id
            request({
                url: "/api/userend/post/postList",
                method: "get",
                params: this.query
            }).then(response => {
                this.list = response.data;
                if(this.list.length < this.query.limit){
                    this.noMore=true
                }
                this.forumLoading=false
            });
        },
    }
}
</script>
<style lang="scss">
    .userDetails-top{
       position: relative;
        .img{
            width: 100%;
            height: 162px;
            border-radius: 8px 8px 0 0;
        }
        .userDetails-content{
            padding: 0 30px;
            .userDetails-top-user{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                border-bottom: 1px solid #F9FAFD;
                img{
                    width: 159px;
                    height: 159px;
                    border-radius: 50%;
                    transform: translateY(-30px);
                }
                .userDetails-top-user-right{
                    margin-bottom: 20px;
                    width: 100%;
                    padding: 20px 0 0 15px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    .userDetails-top-user-right-user{
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        align-items: center;
                        .userDetails-top-user-right-user-name{
                            font-size: 22px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                            }
                        .userDetails-top-user-right-user-btn{
                            cursor: pointer;
                            background: #F5FAFE;
                            border-radius: 22px;
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            align-items: center;
                            padding: 8px 20px;
                            .el-icon-plus{
                                size: 24px;
                                color: #3D7EFF;
                            }
                            span{
                                font-size: 20px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #3D7EFF;
                            }
                        }
                    }
                    .userDetails-top-user-right-id{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #506176;
                        // margin-top: 10px;
                    }
                    .userDetails-top-user-right-content{
                        font-size: 18px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #1E2134;
                        line-height: 25px;
                        // margin-top: 13px;
                    }
                }
            }
            .userDetails-top-user-title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #1E2134;
                margin-top: 15px;
                padding-bottom: 15px;
                border-bottom: 1px solid #F9FAFD;
            }
            .forum{
                p{
                    text-align: center;
                    padding: 5px 0 15px 15px;
                }
                .nodata{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    img{
                        width: 357px;
                        height: 300px;
                    }
                    span{
                        font-size: 22px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
        }
    }
</style>